const MODAL_SELECTOR = '.modal';
const MODAL_FLAG = 'modalRelocated';
const MODAL_ORIGIN_ATTR = 'modalOrigin';

const describeOrigin = (element) => {
  if (!element) {
    return '';
  }

  if (element.id) {
    return `#${element.id}`;
  }

  const role = element.getAttribute?.('data-modal-origin-id');
  if (role) {
    return `[data-modal-origin-id="${role}"]`;
  }

  const classList = element.classList ? Array.from(element.classList) : [];
  if (classList.length) {
    return `${element.tagName.toLowerCase()}.${classList.join('.')}`;
  }

  return element.tagName ? element.tagName.toLowerCase() : '';
};

const relocateModal = (modal) => {
  if (!modal || modal.dataset[MODAL_FLAG] === '1') {
    return;
  }

  const originParent = modal.parentElement;
  const originDescriptor = describeOrigin(originParent);

  if (originDescriptor) {
    modal.dataset[MODAL_ORIGIN_ATTR] = originDescriptor;
  }

  if (originParent) {
    try {
      Object.defineProperty(modal, '__modalOriginalParent', {
        value: originParent,
        configurable: true,
        enumerable: false,
        writable: false,
      });
    } catch (error) {
      // no-op for browsers that disallow defineProperty on HTMLElements
    }
  }

  document.body.appendChild(modal);
  modal.dataset[MODAL_FLAG] = '1';
};

export function initModalRelocator() {
  const process = (root) => {
    if (!root) {
      return;
    }

    if (root.matches?.(MODAL_SELECTOR)) {
      relocateModal(root);
    }

    root.querySelectorAll?.(MODAL_SELECTOR).forEach(relocateModal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => process(document), { once: true });
  } else {
    process(document);
  }

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            process(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}
